/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2016, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'underscore',
	'../../../widgets/livewidget/nls/StringResources',
	'../../../lib/@waca/core-client/js/core-client/ui/core/View',
	'../../../lib/@waca/dashboard-common/dist/ui/Slider',
	'../../../lib/@waca/dashboard-common/dist/utils/ScaleUtil'
], function(_, stringResources, View, Slider, ScaleUtil) {
	'use strict';

	// Create message map only once
	var _SCALE_MESSAGE_MAP = {};
	_SCALE_MESSAGE_MAP[ScaleUtil.SCALE_VALUE_FEW] = stringResources.get('propScaleFew');
	_SCALE_MESSAGE_MAP[ScaleUtil.SCALE_VALUE_DEFAULT] = stringResources.get('propScaleDefault');
	_SCALE_MESSAGE_MAP[ScaleUtil.SCALE_VALUE_MANY] = stringResources.get('propScaleMany');

	var InfographicScaleView = View.extend({

		init: function(options) {
			InfographicScaleView.inherited('init', this, arguments);
			_.extend(this, options);
		},

		remove: function() {
			if (this.slider) {
				this.slider.off('action:slidestop', this._onWidgetScaleUpdate, this);
			}
			InfographicScaleView.inherited('remove', this, arguments);
		},

		/**
		 * Called to render the flyout with the slider/title to edit scale
		 * @returns Flyout and slider are rendered
		 */
		render: function() {
			// Required to set dimensions of flyout. If not set, will appear tiny
			this.$el.css({
				height: 93,
				width: 200
			});
			var extremes = ScaleUtil.getMinMax(this.widgetValue, this.isPercent);
			var options = {
				el: this.$el[0],
				name: 'scaleSlider',
				label: stringResources.get('propScaleLabel'),
				type: 'slider',
				description: stringResources.get('propScaleDescription'),
				min: extremes.min,
				max: extremes.max,
				step: 1,
				showMinMax: false,
				value: this.currentScaleOption,
				style: 'simple',
				valueFormatter: this.valueFormatter.bind(this)
			};

			this.slider = new Slider(options);
			return this.slider.render();
		},

		/**
		 * Called when the subview has finished rendering
		 */
		notifyRenderComplete: function() {
			if (this.slider) {
				// slider needs to re-layout after it's rendered to ensure size calculations are correct
				this.slider.layout();
				// hook up slider event
				this.slider.on('action:slidestop', this._onWidgetScaleUpdate, this);
			}
		},

		/**
		 * Used to update the model when the scale is changed via the widget. Calls internal function to update model and reRender infographic.
		 */
		_onWidgetScaleUpdate: function() {
			const value = this.slider.getValue();
			this.content.setPropertyValue('value.graphic.currentScaleOption', value);
		},

		/**
		 * Returns the slider text for the given value
		 * @param {string} value
		 * @returns {string}
		 */
		valueFormatter: function(value) {
			return _SCALE_MESSAGE_MAP[value] || value;
		},

		setFocus: function() {
			if (this.slider) {
				this.slider.setFocus();
			}
		}
	});

	return InfographicScaleView;
});
